import { render, staticRenderFns } from "./CampaignCustomersView.vue?vue&type=template&id=db8d8f78&scoped=true"
import script from "./CampaignCustomersView.vue?vue&type=script&lang=js"
export * from "./CampaignCustomersView.vue?vue&type=script&lang=js"
import style0 from "./CampaignCustomersView.vue?vue&type=style&index=0&id=db8d8f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8d8f78",
  null
  
)

export default component.exports